(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pe-products-carousel]').forEach((carousel) => {
    if (carousel.dataset.peProductsReady === 'true') return;

    const track = carousel.querySelector('[data-pe-products-track]');
    const previous = carousel.parentElement.querySelector('[data-pe-products-previous]');
    const next = carousel.parentElement.querySelector('[data-pe-products-next]');
    const progress = carousel.querySelector('[data-pe-products-progress]');

    if (!track) return;

    carousel.dataset.peProductsReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.pe-product-card');
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const updateNavigation = () => {
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 1;

      if (previous) previous.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;
      if (progress) progress.style.transform = `scaleX(${0.24 + ratio * 0.76})`;
    };

    const move = (direction) => {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    if (previous) previous.addEventListener('click', () => move(-1));
    if (next) next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateNavigation, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    new ResizeObserver(updateNavigation).observe(track);
    requestAnimationFrame(updateNavigation);
  });

  } catch(e) { console.error(e); }
})();
})();
